import _taggedTemplateLiteral from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _toConsumableArray from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _decorate from "@babel/runtime/helpers/esm/decorate";

var _ = function _(t) {
  return t;
},
    _t,
    _t2;
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import { html, property, internalProperty, customElement, LitElement } from 'lit-element';
import settings from 'carbon-components/es/globals/js/settings';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from "../../globals/mixins/stable-selector.js";
import styles from "./image.css.js";
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
/**
 * Image.
 *
 * @element dds-image
 * @slot long-description - The long description content.
 * @slot icon - The icon content.
 */

var DDSImage = _decorate([customElement("".concat(ddsPrefix, "-image"))], function (_initialize, _StableSelectorMixin) {
  var DDSImage = /*#__PURE__*/function (_StableSelectorMixin2) {
    _inherits(DDSImage, _StableSelectorMixin2);

    var _super = _createSuper(DDSImage);

    function DDSImage() {
      var _this;

      _classCallCheck(this, DDSImage);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return DDSImage;
  }(_StableSelectorMixin);

  return {
    F: DDSImage,
    d: [{
      kind: "field",
      decorators: [internalProperty()],
      key: "_images",
      value: function value() {
        return [];
      }
    }, {
      kind: "method",
      key: "_handleSlotChange",
      value:
      /**
       * The image data, harvested from `<dds-image-item>`.
       */

      /**
       * Handles `slotchange` event.
       */
      function _handleSlotChange(_ref) {
        var target = _ref.target;
        var selectorItem = this.constructor.selectorItem;
        this._images = target.assignedNodes() // Supports `<dds-image><slot></slot></dds-image>` rendered in shadow DOM
        .reduce(function (acc, node) {
          if (node.tagName === 'SLOT') {
            acc.push.apply(acc, _toConsumableArray(node.assignedNodes()));
          } else {
            acc.push(node);
          }

          return acc;
        }, []).filter(function (node) {
          return node.nodeType === Node.ELEMENT_NODE && node.matches(selectorItem);
        });
      }
      /**
       * The alternate text.
       */

    }, {
      kind: "field",
      decorators: [property()],
      key: "alt",
      value: function value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'default-src'
      })],
      key: "defaultSrc",
      value: function value() {
        return '';
      }
    }, {
      kind: "method",
      key: "render",
      value:
      /**
       * The image source.
       */
      function render() {
        var alt = this.alt,
            defaultSrc = this.defaultSrc,
            images = this._images,
            handleSlotChange = this._handleSlotChange;
        return html(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <slot @slotchange=\"", "\"></slot>\n      <picture>\n        ", "\n        <img class=\"", "--image__img\" src=\"", "\" alt=\"", "\" aria-describedby=\"long-description\" loading=\"lazy\" />\n      </picture>\n      <div id=\"long-description\" class=\"", "--image__longdescription\">\n        <slot name=\"long-description\"></slot>\n      </div>\n      <slot name=\"icon\"></slot>\n    "])), 0, 0, 0, 0, 0, 0)), handleSlotChange, images.map(function (image) {
          return html(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<source media=\"", "\" srcset=\"", "\"></source>"])), 0, 0)), image.getAttribute('media'), image.getAttribute('srcset'));
        }), prefix, defaultSrc, alt, prefix);
      }
      /**
       * A selector that will return image items.
       */

    }, {
      kind: "get",
      static: true,
      key: "selectorItem",
      value: function selectorItem() {
        return "".concat(ddsPrefix, "-image-item");
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function stableSelector() {
        return "".concat(ddsPrefix, "--image");
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value: function value() {
        return styles;
      }
    }]
  };
}, StableSelectorMixin(LitElement));

export default DDSImage;